var map = {
	"./team_1.png": 114,
	"./team_2.png": 115,
	"./team_3.png": 116,
	"./team_4.png": 117,
	"./team_5.png": 118,
	"./team_6.png": 119,
	"./team_7.png": 120,
	"./team_8.png": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 232;